import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { DataWidgetComponent } from 'app/components/new-navigation/rankings/data-widgets/data-widget.component';
import { DeveloperRanking } from 'app/components/new-navigation/rankings/models/developerRanking';

const RISK_LABEL_FAILURE = 'Failure';
const RISK_LABEL_HIGH = 'High';
const RISK_LABEL_MEDIUM = 'Medium';
const RISK_LABEL_LOW = 'Low';
const RISK_LABEL_UNKNOWN = 'N/A';

const RISK_FAILURE = 'failure';
const RISK_HIGH = 'high';
const RISK_MED = 'medium';
const RISK_LOW = 'low';
const RISK_UNKNOWN = 'unknown';

@Component({
  selector: 'risk-severity',
  templateUrl: './risk-severity.html',
  styleUrls: ['./risk-severity.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiskSeverityComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input() data: DeveloperRanking;
  @Input() risk: string = '';

  @Output() interact: EventEmitter<Event> = new EventEmitter<Event>();

  get riskNormalized(): string {
    if (!this.risk || typeof this.risk !== 'string') return RISK_UNKNOWN;

    let r = this.risk.toLowerCase();

    if (r === 'failure' || r === 'f') {
      return RISK_FAILURE;
    }

    if (r === 'high' || r === 'h') {
      return RISK_HIGH;
    }

    if (r === 'medium' || r === 'med' || r === 'm') {
      return RISK_MED;
    }

    if (r === 'low' || r === 'l') {
      return RISK_LOW;
    }

    return RISK_UNKNOWN;
  }

  get riskLabel(): string {
    if (!this.risk || typeof this.risk !== 'string') return RISK_LABEL_UNKNOWN;

    let r = this.risk.toLowerCase();

    if (r === 'failure' || r === 'f') {
      return RISK_LABEL_FAILURE;
    }

    if (r === 'high' || r === 'h') {
      return RISK_LABEL_HIGH;
    }

    if (r === 'medium' || r === 'med' || r === 'm') {
      return RISK_LABEL_MEDIUM;
    }

    if (r === 'low' || r === 'l') {
      return RISK_LABEL_LOW;
    }

    return RISK_LABEL_UNKNOWN;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.risk = this.risk || this.data?.overallRisk;
  }

  @HostListener('click')
  onClick(event: Event) {
    this.interact.emit(event);
  }
}
